/* src/app/components/enrollment/payment-details/payment-details.component.css */
.ant-radio-button-wrapper {
  margin: 0px;
  width: 100%;
}
/*# sourceMappingURL=payment-details.component-YRLOYVVG.css.map */
